import React, { useEffect, useState } from "react";
// import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import axios from "../../API/axios";
import { debounce } from "lodash";
// import { toast } from "react-hot-toast";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { useTranslation } from "react-i18next";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";
import CreatableSelect from "react-select/creatable";
import { fetchSkillsByIndustry, quickAddSkill } from "../../utils/industryScopedMaster";
import {
  creatableSkillSelectDefaults,
  onCreatableInputChange,
} from "../../utils/creatableSelectHelpers";

const UpdateSkills = ({ showSkills, handleUpdateSkillClose, getUserProfile, userUid, skillsData }) => {

  const { t } = useTranslation();
  useEscapeKeyDown(showSkills, handleUpdateSkillClose);

  const [display, setDisplay] = useState(false);
  const [value, setValue] = useState([]);
  const [page, setPage] = useState(0);
  const [typed, setTyped] = useState(skillsData?.skillName || "");
  const [isLoading, setIsLoading] = useState(false);
  const [newCreateoption, setNewCreateoption] = useState("");
  const [options, setOptions] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const sessionId = localStorage.getItem("sessionId");
  const language = localStorage.getItem("Lang");

  const logValue = debounce((typed) => {
    setTyped(typed);
  }, 250);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [errorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [selectedOption, setSelectedOption] = useState(null);
  const [industryList, setIndustryList] = useState([]);
  const [showIndustryInput, setShowIndustryInput] = useState(false);
  const [industryInputValue, setIndustryInputValue] = useState("");

  const getIndustry = () => {
    axios
      .get(`Master/GetFirmIndustryTypeDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.fitid ?? item.fitId,
          label: item.name,
        }));
        setIndustryList(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getIndustry();
  }, []);

  const addOptions = () => {
    if (!selectedOption?.value) return;
    setIsLoading(true);
    fetchSkillsByIndustry({
      fitid: selectedOption?.value,
      search: typed,
      pageNumber: page + 1,
      language,
    })
      .then(({ options: data, totalPages: pages }) => {
        setPage((prevPage) => prevPage + 1);
        setIsLoading(false);
        setOptions((prevOptions) => [...prevOptions, ...data]);
        setTotalPages(pages);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleOpen = () => {
    if (!selectedOption?.value) return;
    setPage(0);
    setOptions([]);
    setIsLoading(true);
    fetchSkillsByIndustry({
      fitid: selectedOption?.value,
      search: typed || "",
      pageNumber: 1,
      language,
    })
      .then(({ options: data, totalPages: pages }) => {
        setPage(1);
        setOptions(data);
        setTotalPages(pages);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChange = (selected) => {
    setValue(selected || []);
    setPage(0);
  };

  const handleInputChange = (typed) => {
    logValue(typed);
    if (!typed) setPage(0);
  };

  const handleMenuScrollToBottom = () => {
    if (page < totalPages) {
      addOptions();
    }
  };

  const seedIndustry = (data, industries) => {
    if (!data || Array.isArray(data)) return;
    const fitid = data.fitid ?? data.fitId ?? data.Fitid;
    const name = (
      data.firmIndustryTypeName ||
      data.industryName ||
      data.FirmIndustryTypeName ||
      ""
    ).trim();
    if ((fitid == null || fitid === "") && !name) return;

    const matched =
      (fitid != null && fitid !== ""
        ? industries?.find(
            (option) =>
              option.value != null && String(option.value) === String(fitid)
          )
        : null) ||
      (name
        ? industries?.find(
            (option) =>
              option.label && option.label.toLowerCase() === name.toLowerCase()
          )
        : null) ||
      (fitid != null && fitid !== "" || name
        ? {
            value: fitid != null && fitid !== "" ? fitid : name,
            label: name || String(fitid),
          }
        : null);

    if (matched) {
      setSelectedOption(matched);
      setIndustryInputValue(matched.label || "");
      setShowIndustryInput(true);
    }
  };

  useEffect(() => {
    if (!showSkills) {
      setDisplay(false);
      setSelectedOption(null);
      setValue([]);
      setTyped("");
      setOptions([]);
      setPage(0);
      setTotalPages(0);
      setShowIndustryInput(false);
      setIndustryInputValue("");
      return;
    }

    if (!skillsData || Array.isArray(skillsData) || !skillsData.skillName) {
      return;
    }

    setValue([
      {
        value: skillsData.skllId || skillsData.skillId || skillsData.skillName,
        label: skillsData.skillName,
      },
    ]);
    setTyped(skillsData.skillName || "");
    seedIndustry(skillsData, industryList);
  }, [showSkills, skillsData, industryList]);

  const UpdateSkill = async () => {
    setDisplay(true);
    const selectedSkills = Array.isArray(value) ? value : value ? [value] : [];
    if (!selectedOption?.value || selectedSkills.length === 0) {
      setWarningToastMessage(t("modals.Please fill all the required fields"));
      setShowWarningToast(true);
      return;
    }

    try {
      const [primary, ...rest] = selectedSkills;
      const postdatadetails = {
        deviceType: "Web",
        sessionId: sessionId,
        fitid: selectedOption?.value,
        skillName: primary.label,
        usrSkllId: skillsData.usrSkllId,
        langKey: language === "en" ? "" : language,
      };
      const resData = await axios.post("UserSkill/UpdateUserSkill", postdatadetails);
      let lastMessage = resData.data.message;

      for (const skill of rest) {
        const addRes = await axios.post("UserSkill/AddUserSkill", {
          deviceType: "Web",
          sessionId: sessionId,
          fitid: selectedOption.value,
          skillName: skill.label,
          langKey: language === "en" ? "" : language,
        });
        lastMessage = addRes.data.message;
      }

      setToastMessage(lastMessage);
      setShowToast(true);
      handleUpdateSkillClose();
      setSelectedOption(null);
      setValue([]);
      setTyped("");
      setOptions([]);
      setPage(0);
      setTotalPages(0);
      setShowIndustryInput(false);
      setIndustryInputValue("");
      getUserProfile();
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const handleIndustryChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setValue([]);
    setOptions([]);
    setPage(0);
    setTyped("");
    setShowIndustryInput(false);
    setIndustryInputValue(selectedOption?.label || "");
  };

  useEffect(() => {
    if (typed && selectedOption?.value) {
      addOptions();
    }
  }, [typed]);

  useEffect(() => {
    let scrollY = 0;

    if (showSkills) {
      scrollY = window.scrollY;

      // Lock scroll
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden'; // 🛠️ Add this line
      document.body.classList.add('modal-open');
    } else {
      // Unlock scroll
      const scrollYValue = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      document.documentElement.style.overflow = ''; // 🛠️ Add this line
      document.body.classList.remove('modal-open');

      window.scrollTo(0, parseInt(scrollYValue || '0') * -1);
    }
  }, [showSkills]);

  return (
    <>
      {showSkills && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6> {t ("User Profile.Update Skill")} </h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleUpdateSkillClose();
                  }}
                />
              </div>
              <div className=" pb-4 settings p-2">
              <div className="mb-2 ">
                <div className="text-start">
                  <label htmlFor="about">
                       {t ("User Profile.Industry")}    
                      <span className='text-danger ms-2'>*</span></label>
                  <Select
                      options={industryList}
                      value={selectedOption}
                      styles={customStyles}
                      onChange={handleIndustryChange}
                      placeholder={t("Manage Companies.Select Industry")}
                      className="dropdownBorder"
                      isClearable
                    />
                </div>
                {display && !selectedOption ? (
                  <span className="error_msg_lbl"> {t ("User Profile.Please Select industry")} </span>
                ) : null}
              </div>
              <div>
                <div className="text-start">
                  <label htmlFor="about">
                       {t ("User Profile.Skills")}    
                      <span className='text-danger ms-2'>*</span></label>
                      <CreatableSelect
                        {...creatableSkillSelectDefaults}
                        value={value}
                        options={options}
                        onMenuOpen={handleOpen}
                        onChange={handleChange}
                        onMenuScrollToBottom={handleMenuScrollToBottom}
                        onInputChange={onCreatableInputChange(handleInputChange)}
                        onCreateOption={async (inputValue) => {
                          const trimmed = String(inputValue || "").trim();
                          if (!trimmed) return;
                          const pending = { label: trimmed, value: trimmed };
                          setValue((prev) => [...(Array.isArray(prev) ? prev : []), pending]);
                          setOptions((prev) => [...prev, pending]);
                          const created = await quickAddSkill({
                            name: trimmed,
                            fitid: selectedOption?.value,
                            sessionId,
                            language,
                          });
                          setValue((prev) => [...(Array.isArray(prev) ? prev.filter((s) => String(s.value) !== trimmed) : []), created]);
                          setOptions((prev) => [...prev.filter((s) => String(s.value) !== trimmed), created]);
                        }}
                        className="dropdownBorder"
                        isDisabled={false}
                        noOptionsMessage={() => t("User Profile.No options")}
                        placeholder={t("User Profile.Search and Select Skill")}
                        invalid={display && (!value || value.length === 0)}
                        styles={customStyles}
                      />
                </div>
                {display && (!value || value.length === 0) ? (
                  <span className="error_msg_lbl">{t ("User Profile.Please Select Skill")} </span>
                ) : null}
              </div>
              </div>
              <div className='mt-2 text-end'>
                <button
                  type="button"
                  className="closebtn me-2"
                  onClick={handleUpdateSkillClose}
                  style={{ width: "70px" }}
                > {t ("User Profile.Close")}
                </button>
                <button
                  type="button"
                  className="mainBtn1"
                  onClick={UpdateSkill}
                  style={{ width: "107px" }}
                >
                  {t ("Manage Job.Update")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />
      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />
      <ErrorToast
        show={showErrorToast}
        message={errorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default UpdateSkills;
